import { TFunction } from 'i18next'

import { LanguageResources } from '@/@types/i18next'
import { Gender } from '@/common/models/person'
import { UserType } from '@/common/models/user'
import { z } from '@/lib/zod'

export const FilterUsersSchema = (t: TFunction<[LanguageResources]>) =>
  z
    .object({
      freeSearch: z.string().nullable().optional(),
      userType: z.nativeEnum(UserType).nullable().optional(),
      gender: z.nativeEnum(Gender).nullable().optional(),
      birthMonth: z.string().nullable().optional(),
      birthYear: z.string().nullable().optional(),
      startCreated: z.date().nullable().optional(),
      endCreated: z.date().nullable().optional(),
      isActive: z.boolean().nullable().optional().default(false),
    })
    .refine(
      (data) => {
        if (data.startCreated && data.endCreated) {
          return data.startCreated <= data.endCreated
        }
        return true
      },
      {
        message: t('registers:users.drawer_filter.validations.start_end_date'),
        path: ['startCreated'],
      },
    )
    .refine((data) => (data.startCreated && !data.endCreated ? false : true), {
      message: t('registers:users.drawer_filter.validations.end_date_required'),
      path: ['endCreated'],
    })

export type FilterUsersForm = z.infer<ReturnType<typeof FilterUsersSchema>>
